/**
 * The shell's display-params hosts — the two divs `TopNavigation` paints for the
 * page's own controls. `DisplayParams.vue` is the only component that teleports
 * into them: `#page-display-params-desktop` at ≥768 px, and
 * `#page-display-params-mobile` into the shell's `⋯` dropdown below that.
 *
 * The mobile opener is painted only while its host actually holds something, and
 * the check cannot be a mount-time count: a page teleports into the host at its
 * own pace (DashboardNew mounts, then its layout renders `DisplayParams`), and a
 * page may render `DisplayParams` with an empty slot — `People.vue` and
 * `Account.vue` both do, and Vue's Teleport still leaves its
 * (empty) text anchors in the target for those. Counting nodes therefore paints an
 * opener over an empty panel, which is the defect this helper exists to prevent.
 *
 * Rule: element children, or non-blank text. Empty anchors are neither.
 */

/** The id of the host the shell's mobile `⋯` dropdown carries. */
export const MOBILE_DISPLAY_PARAMS_HOST_ID = 'page-display-params-mobile';

/** The id of the host the shell paints at ≥768 px (kept beside the mobile one). */
export const DESKTOP_DISPLAY_PARAMS_HOST_ID = 'page-display-params-desktop';

/** What `displayParamsHostHasContent` reads off a host element. */
export interface DisplayParamsHostLike {
  readonly children: { readonly length: number };
  readonly textContent: string | null;
}

/** True when a display-params host holds something a user can actually see. */
export function displayParamsHostHasContent(host: DisplayParamsHostLike): boolean {
  return host.children.length > 0 || (host.textContent ?? '').trim().length > 0;
}
